import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LocaleService } from './locale.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./locale.service";
export class CollectiveService {
    constructor(http, localeService) {
        this.http = http;
        this.localeService = localeService;
    }
    getPublicData() {
        let serviceUrl = `${environment.apiUrl}/${environment.apiVersion}/public/collective/${environment.apiKey}?l=${this.localeService.getLocale()}`;
        return new Promise((resolve, reject) => {
            this.http.get(serviceUrl)
                .subscribe((data) => {
                if (data && data['code'] == 200 && data['data'] &&
                    (data['data'].active === 0 || data['data'].active === 1)) {
                    resolve(data['data']);
                    return;
                }
                const responseCode = data && data['code'] !== undefined ? data['code'] : 'unknown';
                const error = new Error(`Invalid collective public data response (code: ${responseCode})`);
                console.error('Could not load collective public data.', error);
                reject(error);
            }, error => {
                console.error('Could not load collective public data.', error);
                reject(error);
            });
        });
    }
}
CollectiveService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CollectiveService_Factory() { return new CollectiveService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LocaleService)); }, token: CollectiveService, providedIn: "root" });
